import styled from "styled-components";

const NavTitle = styled.div`
  padding: 20px;
  font-weight: bold;
  background-color: #a6d9fd;
`;

export { NavTitle };
